import React from 'react'
import LottiePlayer from "lottie-react";
import noDataFoundOne from '../../component/Pages/noDataFound.json'

const NoResult = ({message='No Result Found'}) => {


  return (
    <>
  
        <div className="no-data-found">

            <LottiePlayer
              animationData={noDataFoundOne}
              style={{ height: 200 }}
              autoplay
              loop
            />
            <h5 style={{ marginTop: '-10px' }}>{message}</h5>
            <p></p>
          
        </div>
  
    </>
  )
}

export default NoResult;